import Service from './Service';

class BorkerService extends Service {
    getBrokerData() {
        return this.get('kgfb/kgfb-broker-data', {});
    }
}

export default new BorkerService('/');
